import { useContext } from 'react'

import { Context } from './toast.context'

export const useToast = () => {
  const context = useContext(Context)

  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider')
  }

  return context
}
